// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN RUST INSTEAD.

// @ts-ignore
import { __SPACETIMEDB__, AlgebraicType, SumTypeVariant, BuiltinType, AlgebraicValue } from "@clockworklabs/spacetimedb-sdk";

export namespace DataType {
	export function getAlgebraicType(): AlgebraicType {
		return AlgebraicType.createSumType([
			new SumTypeVariant("TextElement", AlgebraicType.createProductType([
		])),
			new SumTypeVariant("ImageElement", AlgebraicType.createProductType([
		])),
			new SumTypeVariant("WidgetElement", AlgebraicType.createProductType([
		])),
		]);
	}

	export function serialize(value: DataType): object {
		const result: {[key: string]: any} = {};
		result[value.tag] = [];
		return result;
	}

	export type TextElement = { tag: "TextElement", value: undefined };
	export const TextElement = { tag: "TextElement", value: undefined };
	export type ImageElement = { tag: "ImageElement", value: undefined };
	export const ImageElement = { tag: "ImageElement", value: undefined };
	export type WidgetElement = { tag: "WidgetElement", value: undefined };
	export const WidgetElement = { tag: "WidgetElement", value: undefined };

	export function fromValue(value: AlgebraicValue): DataType {
		let sumValue = value.asSumValue();
		let tag = sumValue.tag;
		let variant = DataType.getAlgebraicType().sum.variants[tag];
		return { tag: variant.name, value: undefined } as DataType;
	}
}

export type DataType = DataType.TextElement | DataType.ImageElement | DataType.WidgetElement;
export default DataType;
